module.exports=require("node-i18n-util/lib/client-bundle")("nls/setup/deploy/deploy.properties")